module.exports = __webpack_public_path__ + "img/Certificate_16.8b8aac16.jpg";